import { Swiper } from 'vue-awesome-swiper';
import Service from '../service-service';
import { mapGetters } from 'vuex';
import PartnerService from '@/views/socialized-service/partner/org-service';
import ImageViewer from '@/views/socialized-service/share/image-viewer/index.vue';
export default {
  components: {
    ImageViewer
  },
  data() {
    return {
      detail: {},
      slides: [],
      showPhone: true,
      isPhoneVisible: false,
      companyInfo: {
        coverImg: []
      },
      isShow: false
    };
  },
  computed: {
    ...mapGetters([
      'isSignin',
      'userInfo'
    ]),
    srcList() {
      let list = [];
      if (this.companyInfo.coverImg) {
        list = this.companyInfo.coverImg.map(item => item.image && item.image.url);
      }
      return list;
    }
  },

  watch: {
    slides (newValue) {
      if (newValue) {
        this.$nextTick(() => {
          this.galleryThumbsLunbo();
          this.galleryTopLunbo();
        });
      }
    }
  },

  created() {
    this.getServiceDetail();
    this.getPartnerDetail();
  },
  methods: {
    getServiceDetail() {
      Service.getServiceDetail({id: this.$route.query.id}).then(res => {
        this.detail = res;
        this.slides = res.listImages;
      });
    },

    getPartnerDetail() {
      PartnerService.getPartnerDetail({id: this.$route.query.partnerId, type: 'arongqi'}).then(res => {
        this.companyInfo = res;
      });
    },
    // 联动轮播
    galleryThumbsLunbo() {
      if ( this.galleryThumbs) {
        this.galleryThumbs.destroy();
      }
      this.galleryThumbs = new Swiper('.gallery-thumbs', {
        spaceBetween: 15,    // 在slide之间设置距离（单位px）
        slidesPerView: 5,    // 设置slider容器能够同时显示的slides数量
        loop: false,        // 设置为true 则开启loop模式
        freeMode: true,    // 默认为false，普通模式：slide滑动时只滑动一格
        loopedSlides: 5,    // 一般设置大于可视slide个数2个即可
        watchSlidesVisibility: true,   // 开启watchSlidesVisibility选项前需要先开启watchSlidesProgress
        watchSlidesProgress: true   // 开启这个参数来计算每个slide的progress(进度、进程)
      });
    },
    galleryTopLunbo() {
      if ( this.galleryTop) {
        this.galleryTop.destroy();
      }
      this.galleryTop = new Swiper('.gallery-top', {
        autoplay: true,
        spaceBetween: 10,
        loop: false,
        loopedSlides: 5,
        // 左右按钮
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        thumbs: {        // thumbs组件专门用于制作带缩略图的swiper
          swiper: this.galleryThumbs
        }
      });
    },
    changeActiveIndex (index) {
      console.log(index);
      this.$refs.carousel.slideTo(index);
      this.$refs.carousel.update();
    },
    updateCarousel() {
      this.$refs.carousel.update();
    },
    toApplyPage() {
      if (!this.isSignin) {
        this.$router.push('/signin');
        return;
      }
      this.$router.push('/socialized-service/service/apply?id=' + this.$route.query.id + '&type=001');
    },
    goBack() {
      this.$router.back();
    },
    togglePhoneDisplay() {
      this.isPhoneVisible = !this.isPhoneVisible;
      this.showPhone = !this.showPhone;
    }
  }
};
